<template>
  <el-dialog
    style="z-index: 9!important;"
    top="5vh"
    z-index="90"
    :modal-append-to-body="false"
    :append-to-body="true"
    title="查看消息"
    :visible="visible"
    :show-close="false"
  >
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="发送方式">
        {{form.send_type == 1 ? '按所有' : '按基地'}}
      </el-form-item>
      <template v-if="form.send_type == 2">
        <el-form-item label="所属基地">
          {{ baseInfo.com_name }}
        </el-form-item>
        <el-form-item label="发送范围">
          {{form.send_scope||'按所有'}}
        </el-form-item>
      </template>
      <el-form-item label="消息标题">
        {{form.title}}
      </el-form-item>
      <el-form-item label="内容详情">
        <div v-html="form.content"></div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="onCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      notice_editor: null,
      form: {},
      rules: {
        send_type: [
          { required: true, message: "请输入发送方式", trigger: "change" }
        ],
        send_role: [
          { required: true, message: "请选择发送角色", trigger: "change" }
        ],
        title: [{ required: true, message: "请输入消息标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入正文", trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "baseRole"]),
    baseRoleMap() {
      const map = {};
      this.baseRole.forEach(item => {
        map[item.id] = item.name;
      });
      return map;
    }
  },
  methods: {
    onOpen(row) {
      console.log(row);
      this.form = row || {
        send_type: "",
        send_role: [],
        title: "",
        content: ""
      };
      this.visible = true;
    },
    onCancel() {
      this.form = {};
      this.$nextTick(() => {
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
